import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c76340e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchbar-container" }
const _hoisted_2 = { class: "input-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchResults = _resolveComponent("SearchResults")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        placeholder: "Search Places...",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event))
      }, null, 512), [
        [_vModelText, _ctx.searchTerm]
      ]),
      (_ctx.searchTerm)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearInput && _ctx.clearInput(...args))),
            class: "btn btn-outline-secondary",
            type: "button"
          }, " × "))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_SearchResults)
  ]))
}